import { render, staticRenderFns } from "./ZhiNan.vue?vue&type=template&id=55037279&scoped=true&"
import script from "./ZhiNan.vue?vue&type=script&lang=js&"
export * from "./ZhiNan.vue?vue&type=script&lang=js&"
import style0 from "./ZhiNan.vue?vue&type=style&index=0&id=55037279&prod&scoped=scoped&lang=css&"
import style1 from "./ZhiNan.vue?vue&type=style&index=1&id=55037279&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55037279",
  null
  
)

export default component.exports